import DonateNavigationButton from "@/components/donations/DonateNavigationButton"
import LoggedOutRoutes from "@/components/navigation/LoggedOutRoutes"
import CustomerPaperHeader from "@/components/utils/CustomerPaperHeader"
import Page from "@/components/utils/Page"
import Paper from "@mui/material/Paper"
import { memo } from "react"

const LoggedOutStructure = () => {
  return (
    <Page>
      <CustomerPaperHeader accessScreen />
      <Paper>
        <LoggedOutRoutes />
      </Paper>
      <DonateNavigationButton />
    </Page>
  )
}

export default memo(LoggedOutStructure)
